import React from 'react';
import { motion } from 'framer-motion';

const Gratitude = () => {
  return (
    <section id="gratitude" className="scroll-mt-24 px-6 py-20 lg:px-8 lg:py-24 overflow-hidden">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-12 lg:grid-cols-5 lg:gap-16">
          <motion.div 
            initial={{ opacity: 0, x: -30, scale: 0.95 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="lg:col-span-2"
          >
            <div className="aspect-[3/4] overflow-hidden rounded-3xl bg-lotus-petal/40 shadow-xl outline outline-1 -outline-offset-1 outline-lotus-ink/10 group">
              <img
                src="/images/master-choa-kok-sui.jpg"
                alt="Grand Master Choa Kok Sui, modern founder of Pranic Healing"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
            className="lg:col-span-3"
          >
            <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
              In Gratitude
            </span>
            <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
              Grand Master Choa Kok Sui
            </h2>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-lotus-deep/70 font-medium">
              Modern Founder of Pranic Healing & Arhatic Yoga
            </p>
            <p className="mt-6 text-lg leading-relaxed text-lotus-ink/70">
              Our practice is inspired by the teachings of Grand Master Choa Kok Sui, whose life's work made the ancient science of energy healing accessible to the modern world.
            </p>
            <blockquote className="mt-8 border-l-2 border-lotus-deep/40 pl-6 font-serif text-lg italic leading-relaxed text-lotus-deep">
              "What is impossible for an ordinary person is possible with the blessings of God, the guru and the higher beings."
              <footer className="mt-3 text-xs not-italic uppercase tracking-[0.25em] text-lotus-deep/80 font-medium">
                — Master Choa Kok Sui
              </footer>
            </blockquote>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Gratitude;
